
import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import { FileDocument, fileDocumentName } from '@/model';

export default Vue.extend({
  name: 'DocumentPicker',
  components: { Multiselect },

  props: {
    value: { type: Array as () => FileDocument[], required: true },
    // single: { type: Boolean, default: false },
    // closeOnSelect: { type: Boolean, default: true },
    documents: { type: Array as () => FileDocument[], default: () => [] },
  },

  data() {
    return {
    };
  },

  computed: {

  },

  methods: {
    input(documents: FileDocument[]) {
      this.$emit('input', documents);
    },
    name(document: FileDocument) {
      return fileDocumentName(document);
    },
  },

});
